import type { SelectProps } from '@flex-design-system/fx';
import { Select } from '@flex-design-system/fx';
import { Translation } from '@flex-packages/i18n';

import { isVeteranWhether, VeteranWhether } from '../../base';

interface VerteranSelectProps extends SelectProps {
  veteran?: VeteranWhether;
  onVeteranChange: (newVeteran: VeteranWhether) => void;
}

function VeteranSelect({
  children,
  veteran,
  onVeteranChange,
  ...props
}: VerteranSelectProps) {
  return (
    <Select
      {...props}
      value={veteran}
      onValueChange={value => {
        if (!isVeteranWhether(value)) {
          return;
        }
        onVeteranChange(value);
      }}
    >
      <Select.Trigger asChild>{children}</Select.Trigger>
      <Select.Content onCloseAutoFocus={e => e.preventDefault()}>
        <Select.Option value={VeteranWhether.Included}>
          <Select.OptionTitle>
            <Translation tKey="recruiting.veteran.included" />
          </Select.OptionTitle>
        </Select.Option>
        <Select.Option value={VeteranWhether.NotIncluded}>
          <Select.OptionTitle>
            <Translation tKey="recruiting.veteran.not_included" />
          </Select.OptionTitle>
        </Select.Option>
      </Select.Content>
    </Select>
  );
}

export default VeteranSelect;
